import React, { useEffect, useRef, useState } from 'react';
import styles from './Events.module.css';
import { eventosLogic, IEvento } from '../../../../Logic/Eventos';

const Events = () => {
  const [nombre, setNombre] = useState('');
  const [fecha, setFecha] = useState('');
  const [imagen, setImagen] = useState<File | null>(null);
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [eventos, setEventos] = useState<IEvento[]>([]);

  useEffect(() => {
    try 
    {
        const func = async () => await getAllEvents();   
        func();
    } catch (err) {
    console.error("Error al obtener los eventos", err);
    }
  }, []);

  const getAllEvents = async ()  => {
    await eventosLogic.GetAllEvents().then(response => {
        setEventos(response);
    });    
  }

  const handleDelete = async (id: number) => {
    // eslint-disable-next-line no-restricted-globals
    if (!confirm('¿Estás seguro de eliminar este evento?')) return;
  
    try 
    {
       await eventosLogic.DeleteEvent(id).then(response => {
        
        if (!response) throw new Error('Error al eliminar evento');

        setEventos(eventos.filter(e => Number(e.EventoID) !== id)); // Elimina localmente el evento
       });
      
    } catch (err) {
      console.error("Error al eliminar el evento", err);
      setError('No se pudo eliminar el evento.');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setImagen(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMensaje('');
    setError('');
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('Nombre', nombre);
      formData.append('Fecha', fecha);

      if (imagen) formData.append('Imagen', imagen);

      await eventosLogic.UploadEvent(formData).then(response => {

        if (!response) throw new Error('Error al enviar el formulario');

        setMensaje('Evento creado exitosamente')
      });
        
    } catch (err) {
      setError('No se pudo crear el evento.');
    } finally {
      setLoading(false);
      setNombre('');
      setFecha('');
      setImagen(null); 
      await getAllEvents();   

        // También limpia el input de archivo usando una referencia
        if (fileInputRef.current) 
            fileInputRef.current.value = '';

        setTimeout(() => setMensaje(''), 2000); // 2 segundos
        
    }
  };

  return (
  <>
  <hr></hr>
            <div className={styles.formContainer}>
                <h2>Crear Evento</h2>
                <form onSubmit={handleSubmit}>
                    <label className={styles.inputLabel}>Nombre</label>
                    <input className={styles.inputField} value={nombre} onChange={(e) => setNombre(e.target.value)} required />

                    <label className={styles.inputLabel}>Fecha</label>
                    <input type="date" className={styles.inputField} value={fecha} onChange={(e) => setFecha(e.target.value)} required />

                    <label className={styles.inputLabel}>Imagen</label>
                    <input type="file" className={styles.inputField} onChange={handleImageChange} accept="image/*"  ref={fileInputRef} required />

                    <button type="submit" className={styles.submitButton} disabled={loading}>
                    {loading ? 'Guardando...' : 'Crear Evento'}
                    </button>
                </form>

                {mensaje && <div className={styles.successMessage}>{mensaje}</div>}
                {error && <div className={styles.errorMessage}>{error}</div>}
                </div>

            {eventos.length > 0 && (
                <div className={styles.eventList}>
                <h3>Eventos registrados</h3>
                <ul style={{padding: "0px"}}>
                    {eventos.map(evento => (
                    <li key={evento.EventoID} className={styles.eventItem}>
                        <img 
                            src={evento.Imagen} 
                            alt={evento.Nombre} 
                            className={styles.thumbnail}
                        />
                        <span className={styles.eventName} >{evento.Nombre} - {evento.Fecha}</span>
                        <button onClick={() => handleDelete(Number(evento.EventoID))} className={styles.deleteButton}>Eliminar</button>
                    </li>
                    ))}
                </ul>
                </div>)}

    </>
                
  );
};

export default Events;
